// Drawer config
// Used by drawer and content
export const drawerWidthOpen = 260;
export const drawerWidthClosedDesktop = 58;
